import React, { useEffect, useState } from "react";
import styled from "@emotion/styled";
import GenderTab from "@components/tab/GenderTab";
import {
  AdSwiper,
  BrandSwiper,
  EventSwiper,
  LovesSwiper,
  NewInSwiper,
} from "@pages/home/_components";
import LoginModal from "@components/modal/LoginModal";
import useAuth from "@hook/useAuth";
import SellerSwiper from "./_components/SellerSwiper";

const Container = styled.div({
  display: "flex",
  flexDirection: "column",
  gap: "3.8rem",
  padding: "0 2rem",
});

const Home = () => {
  const [isOpen, setIsOpen] = useState(false);

  const { isAuthenticated } = useAuth();

  useEffect(() => {
    !isAuthenticated && setIsOpen(true);
  }, [isAuthenticated]);

  return (
    <Container>
      {/*성별 필터*/}
      <GenderTab />

      {/*이벤트 Swiper*/}
      <EventSwiper />

      {/*브랜드 Swiper*/}
      <BrandSwiper />

      {/*셀러 Swiper*/}
      <SellerSwiper />

      {/*광고 Swiper*/}
      <AdSwiper />

      {/*He Loves Swiper*/}
      <LovesSwiper />

      {/*NewIn Swiper*/}
      <NewInSwiper />

      <LoginModal open={isOpen} setOpen={setIsOpen} />
    </Container>
  );
};

export default Home;
